import { Heart, Ear, Award, Lock } from 'lucide-react';

export default function Values() {
  const values = [
    {
      icon: <Heart className="w-8 h-8 text-aurore-dark dark:text-aurore-light" />,
      title: "Réponse rapide",
      description: "Vous m'écrivez ou m'appelez ? Je vous réponds sous 24h. Pas de boîte vocale sans retour."
    },
    {
      icon: <Ear className="w-8 h-8 text-aurore-dark dark:text-aurore-light" />,
      title: "J'écoute d'abord",
      description: "Je ne balance pas de solution toute faite. Je prends le temps de comprendre votre contexte réel."
    },
    {
      icon: <Award className="w-8 h-8 text-aurore-dark dark:text-aurore-light" />,
      title: "Langage clair",
      description: "Mon expertise est là pour vous aider, pas pour vous perdre dans le jargon juridique."
    },
    {
      icon: <Lock className="w-8 h-8 text-aurore-dark dark:text-aurore-light" />,
      title: "Confidentialité totale",
      description: "Ce que vous me dites reste entre nous. Zéro jugement, zéro fuite."
    }
  ];

  return (
    <section className="py-24 bg-aurore-pale dark:bg-warm-gray-800">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-4 px-5 py-2.5 bg-aurore-light/50 dark:bg-warm-gray-700 rounded-full">
              <span className="text-aurore-dark dark:text-aurore-light text-sm font-medium">Comment je travaille</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-warm-gray-900 dark:text-warm-gray-100 mb-8 leading-tight">
              Ce sur quoi vous pouvez compter quand vous m'appelez
            </h2>

            <p className="text-xl text-warm-gray-700 dark:text-warm-gray-300 max-w-3xl mx-auto leading-relaxed-plus">
              Pas de langue de bois. Pas de jargon. Juste une vraie écoute et des réponses claires à vos questions.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="text-center p-8 rounded-2xl bg-white/60 dark:bg-warm-gray-900/60 backdrop-blur-sm hover:bg-white dark:hover:bg-warm-gray-900 hover:shadow-lg transition-all duration-500 ease-out"
              >
                <div className="w-20 h-20 bg-aurore-light/40 dark:bg-warm-gray-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-warm-gray-900 dark:text-warm-gray-100 mb-4">{value.title}</h3>
                <p className="text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed-plus">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
